import { PropsWithChildren } from 'react'
import { styled } from 'styled-components'

import { BREAKPOINT_DESKTOP_PX } from '../global/constants'
import { FullWidthPageContentSection, Section } from '../global/LayoutStyling'

const footerAttributes = {
  role: 'region',
}

const FooterSection = styled(FullWidthPageContentSection).attrs(footerAttributes)``
const FooterContent = styled(Section)`
  padding-bottom: 0px;
`

const ContentWrapper = styled.div<{ fullWidthFooter?: boolean }>`
  max-width: ${(props) => (!props.fullWidthFooter ? `${BREAKPOINT_DESKTOP_PX - 1}px;` : 'inherit')};
`

export interface FooterProps {
  fullWidthFooter?: boolean
}

export const Footer = (props: PropsWithChildren<FooterProps>) => {
  if (!props.children) {
    return
  }

  return (
    <FooterSection $backgroundColor={'transparent'}>
      <ContentWrapper fullWidthFooter={!!props.fullWidthFooter}>
        <FooterContent halfHorizontalPadding={!!props.fullWidthFooter}>{props.children}</FooterContent>
      </ContentWrapper>
    </FooterSection>
  )
}
